import store from '@/store';
import router from '@/router';

export const soundList = {
  general: 'GENERAL',
  loop: 'LOOP',
  swipeLeft: 'SWIPE_LEFT',
  swipeRight: 'SWIPE_RIGHT',
  backPackClose: 'BACKPACK_CLOSE',
  backPackOpen: 'BACKPACK_OPEN',
  cardClose: 'CARD_CLOSE',
  cardOpen: 'CARD_OPEN',
  cow: 'COW',
  car: 'CAR',
  sea: 'SEA',
  rooster: 'ROOSTER',
  hoho: 'HOHO',
  frogs: 'FROGS',
  bleep: 'BLEEP',
  phone: 'PHONE',
  plane: 'PLANE',
};

const soundAudio = {};

function initAudioSounds() {
  // Main loop sound
  soundAudio.LOOP = new Audio('/sounds/loop.mp3');
  soundAudio.LOOP.volume = isIosDevice() ? 0.04 : 0.2;

  // Sound effects
  soundAudio.GENERAL = new Audio('/sounds/general_button.mp3');
  soundAudio.GENERAL.volume = 0.9;
  soundAudio.SWIPE_LEFT = new Audio('/sounds/swipe_left.mp3');
  soundAudio.SWIPE_LEFT.volume = 1;
  soundAudio.SWIPE_RIGHT = new Audio('/sounds/swipe_right.mp3');
  soundAudio.SWIPE_RIGHT.volume = 1;
  soundAudio.BACKPACK_CLOSE = new Audio('/sounds/backpack_close.mp3');
  soundAudio.BACKPACK_CLOSE.volume = 0.9;
  soundAudio.BACKPACK_OPEN = new Audio('/sounds/backpack_open.mp3');
  soundAudio.BACKPACK_OPEN.volume = 0.9;
  soundAudio.CARD_CLOSE = new Audio('/sounds/card_folder_close.mp3');
  soundAudio.CARD_CLOSE.volume = 0.9;
  soundAudio.CARD_OPEN = new Audio('/sounds/card_folder_open.mp3');
  soundAudio.CARD_OPEN.volume = 0.9;
  soundAudio.COW = new Audio('/sounds/cow.mp3');
  soundAudio.COW.volume = 0.9;
  soundAudio.CAR = new Audio('/sounds/car.mp3');
  soundAudio.CAR.volume = 0.9;
  soundAudio.SEA = new Audio('/sounds/sea.mp3');
  soundAudio.SEA.volume = 0.9;
  soundAudio.ROOSTER = new Audio('/sounds/rooster.mp3');
  soundAudio.ROOSTER.volume = 0.9;
  soundAudio.HOHO = new Audio('/sounds/hoho.mp3');
  soundAudio.HOHO.volume = 0.9;
  soundAudio.FROGS = new Audio('/sounds/frogs.mp3');
  soundAudio.FROGS.volume = 0.9;
  soundAudio.BLEEP = new Audio('/sounds/bleep.mp3');
  soundAudio.BLEEP.volume = 0.9;
  soundAudio.PHONE = new Audio('/sounds/phone.mp3');
  soundAudio.PHONE.volume = 0.9;
  soundAudio.PLANE = new Audio('/sounds/plane.mp3');
  soundAudio.PLANE.volume = 0.9;
}

initAudioSounds();

export function soundPlayer(sound, endListener, force = false) {
  const soundActive = store.getters['settings/soundActive'];
  const rollSound = soundAudio[sound];
  const soundTimeout = sound === soundList.general ? 0 : 600;
  if (soundActive || force) {
    if (endListener) {
      rollSound.addEventListener('ended', endListener, false);
    }
    setTimeout(() => {
      rollSound.play().catch(() => { return; });
    }, soundTimeout);
  }
}

class LoopSong {
  rollSound = soundAudio.LOOP;

  constructor() {
    if (typeof this.rollSound.loop === 'boolean') {
      this.rollSound.loop = true;
    } else {
      const loopSound = this.rollSound;
      loopSound.addEventListener('ended', () => {
        loopSound.play().catch(() => { return; });
      }, false);
    }
  }

  play() {
    const soundActive = store.getters['settings/soundActive'];
    const currentRouteName = router.currentRoute.name;
    if (currentRouteName !== 'player' && soundActive) {
      this.rollSound.play().catch(() => { return; });
    } else {
      this.pause();
    }
  }

  pause() {
    this.rollSound.pause();
  }
}

const Loop = new LoopSong();

export default Loop;

function isIosDevice() {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}

// Set the name of the hidden property and the change event for visibility
let hidden;
let visibilityChange;
if (typeof document.hidden !== 'undefined') {
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
}

// If the page is hidden, pause the video;
// if the page is shown, play the video
function handleVisibilityChange() {
  const doc = document;
  if (doc[hidden]) {
    Loop.pause();
  } else {
    Loop.play();
  }
}

// Handle page visibility change
document.addEventListener(visibilityChange, handleVisibilityChange, false);
